import { useLocation } from "react-router-dom";
import classNames from "classnames";
import { getMainScreenVariant } from "../../../../config/runtimeConfig";
import NavButton from "./NavButton";
import CartButton from "./CartButton";
import styles from "./DesktopNavigation.module.scss";
import { useDesktopButtons } from "../useNavButtons";

export default function DesktopNavigation() {
  const location = useLocation();
  const mainScreenVariant = getMainScreenVariant();

  const desktopButtons = useDesktopButtons();

  return (
    <>
      <CartButton />
      <nav
        className={classNames(styles.desktopNav, {
          [styles.categoriesMode]: mainScreenVariant === "categories",
        })}
      >
        <div className={styles.navContent}>
          {desktopButtons.map((button) => (
            <NavButton
              key={button.path || button.label}
              icon={button.icon}
              to={button.onClick ? undefined : button.path}
              onClick={button.onClick}
              label={button.label}
              isActive={
                button.onClick ? false : location.pathname === button.path
              }
            />
          ))}
        </div>
      </nav>
    </>
  );
}
